<template>
    <div class="container">
        <div class="row">
            <div class="col-md-12">
            	<div class="col-12 mt-4 mb-4 validate-voucher">
                    <div class="card">
                        <div class="card-header">
                            <div class="row">
                                <div class="col-md-12">
                                    <img class="img-fluid" v-bind:src="'/img/logo-white.png'" height="53"  width="150" alt="Gifted PH" title="Gifted PH" />
                                </div>
                                

                            </div>
                        </div>
                        <div class="card card-title">
                           <h3>Validate Voucher Code</h3>
                        </div>
                        <div class="card-body text-center">
                            <form id="validateForm" action="" enctype="multipart/form-data" method="POST" v-on:submit.prevent="checkIfRecaptchaVerified">
                                <div class="form-group">
                                    <input type="text" class="form-control form-control-lg" name="voucher_code" id="voucher_code" required="" placeholder="Enter Voucher Code" onkeyup="this.value = this.value.toUpperCase();" />
                                </div>
                                <div class="form-group">
                                    <div style="width: 100%;overflow: hidden;margin: 0 auto 5px;max-width: 304px;position: relative;clear: both;">
                                        <vue-recaptcha @verify="markRecaptchaAsVerified" sitekey="6Lf75zEUAAAAAI3SawkXu1GCgLeDaZbfvudKzDMX" :loadRecaptchaScript="true"></vue-recaptcha>
                                    </div>
                                </div>
                                <button type="submit" name="submit" class="btn btn-verify">Submit</button>
                                <input type="hidden" name="_token" v-bind:value="csrf">

                                <div  v-if="validateForm.pleaseTickRecaptchaMessage != ''" class="alert alert-warning text-center" role="alert" style="margin: 15px auto 0;">
                                    {{ validateForm.pleaseTickRecaptchaMessage }}
                                </div>

                            </form>
                            <div id="validateResults" style="text-align: left;">
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style>
    .swal2-select{
        margin: 0 auto;
        width: 100%;
        max-width: 265px;
        border-radius: 5px;
        -moz-appearance:none; /* Firefox */
        -webkit-appearance:none; /* Safari and Chrome */
        appearance:none;
        background: url('/img/dropdown-arrow.png') no-repeat right center;
        background-size: contain;
    }
    .swal2-select:focus{
        border: 1px solid #DE3C4C;
        outline: none;
    }
    .swal2-validation-message{
        background-color: transparent;
    }

    .validate-voucher .otp-input {
        width: 50px;
        height: 50px;
        padding: 5px;
        margin: 0 10px;
        font-size: 20px;
        border-radius: 4px;
        border: 1px solid rgba(0, 0, 0, 0.3);
        text-align: center;
    }
    .validate-voucher .otp{

    }
    .validate-voucher .otp .otp-input.error {
        border: 1px solid red !important;
    }
    .validate-voucher .otp .otp-input::-webkit-inner-spin-button,
    .validate-voucher .otp .otp-input::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
    button.btn-mark-redeemed{
        width: 100%;
        background-color: #DE3C4C;
        color: #fff;
        font-size: 20px;
        outline: 0;
        border: 0;
        max-width: 302px;
        margin: 0 auto;
    }
    button.btn-mark-redeemed:hover, button.btn-mark-redeemed:focus{
        outline: 0;
        border: 0;
    }
    .voucher-details{
        text-align: left;
    }
    .voucher-details .form-group label{
        
    }
    .voucher-details .form-group p{
        text-align: center;
    }
</style>
<style scoped>
    .validate-voucher{
        max-width: 500px;
        margin: 0 auto;
    }
    .validate-voucher .card-header{
        background-color: #DE3C4C;
    }
    .validate-voucher .card-header .title{
        font-size: 30px;
        color: #fff;
        text-align: right;
        margin: 0 auto;
        padding: 8px 0;

    }
    .validate-voucher .card-body{
        padding: 20px 20px 40px; 
    }
    .validate-voucher .card-title{
        border: 0;
        margin: 0;
    }
    .validate-voucher .card-title h3{
        text-align: center;
        padding: 15px;
        background-color: #eee;
        margin: 0;
    }

    .validate-voucher input[name=voucher_code]{
        text-align: center;
        max-width: 302px;
        margin: 0 auto;
    }

    .validate-voucher button.btn-verify{
        width: 100%;
        background-color: #DE3C4C;
        color: #fff;
        font-size: 20px;
        outline: 0;
        border: 0;
        max-width: 302px;
        margin: 0 auto;
    }
    .validate-voucher button.btn-verify:hover, .validate-voucher button.btn-verify:focus{
        outline: 0;
        border: 0;
    }

    .validate-voucher .alert{
        margin: 15px 0 0;
    }
    

</style>

<script>

    import VueRecaptcha from 'vue-recaptcha'

     export default {
        components: { 
            VueRecaptcha
        },
        props: [],
        data: () => ({
            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            validateForm: {
              recaptchaVerified: false,
              pleaseTickRecaptchaMessage: ''
            }
        }), 
        mounted() {

        },
        methods: {
            markRecaptchaAsVerified(response) {
                this.validateForm.pleaseTickRecaptchaMessage = '';
                this.validateForm.recaptchaVerified = true;
                $(".btn-verify").removeAttr("disabled");

            },
            checkIfRecaptchaVerified() {
                if (!this.validateForm.recaptchaVerified) {
                    this.validateForm.pleaseTickRecaptchaMessage = 'Please tick reCAPTCHA.';
                    return true; // prevent form from submitting
                }
                
                var voucher_code = document.getElementById('voucher_code').value;

                Swal.fire({
                  icon: 'warning',
                  title: 'Please wait!',
                  //html: 'Your voucher is validating...',
                  showConfirmButton: false,
                });

                if(voucher_code){

                    return $.ajax({
                        type: "POST",
                        url: "/api/is_valid",
                        data: { 'code': voucher_code, 'key': '7e41562b6ba7a3bd69482041883d4682f7cadae523b48846c6f5fbaacdf3ba5d' },
                        cache: false,
                    })
                    .then(response => {

                        if(response.status === "Success"){

                            if(response.data.status != "Redeemed"){

                                var is_valid = response.data.status != "Redeemed" ? "Valid":"Not Valid";
                                var merchant_id = response.data.merchant_id;

                                var branch_name_label = merchant_id == 206 ? "Restaurant Name & Branch Name":"Branch Name";

                                Swal.fire({
                                    title: 'Voucher Details',
                                    confirmButtonColor: '#DE3C4C',
                                    confirmButtonText: 'Mark as Redeemed',
                                    showLoaderOnConfirm: true,
                                    showCancelButton: true,
                                    allowOutsideClick: false,
                                    allowEscapeKey: false,
                                    background: '#fff',
                                    backdrop: 'rgb(198, 227, 222)',
                                    html:`
                                    <div class="voucher-details">
                                        <div class="form-group row">
                                            <label class="col-sm-4 col-form-label col-form-label-sm">Product Name:</label>
                                            <div class="col-sm-8" id="product_name">
                                                ${response.data.product_name}
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label class="col-sm-4 col-form-label col-form-label-sm">Voucher:</label>
                                            <div class="col-sm-8" id="voucher_code">
                                                ${response.data.voucher_code}
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label class="col-sm-4 col-form-label col-form-label-sm">Status:</label>
                                            <div class="col-sm-8" id="status">
                                                ${is_valid}
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label class="col-sm-4 col-form-label col-form-label-sm">Amount:</label>
                                            <div class="col-sm-8" id="amount">
                                                &#8369; ${response.data.denomination}
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label class="col-sm-4 col-form-label col-form-label-sm">Date Purchased:</label>
                                            <div class="col-sm-8" id="date_purchased">
                                                ${response.data.ordered_on}
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <div class="col-sm-12">
                                                <p style="margin-bottom: 0;">Please fill the required fields below to complete the redemption of the voucher.</p>
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label for="branch_name">${branch_name_label} <span style="color: #DE3C4C;">*</span></label>
                                            <input type="text" class="form-control" id="branch_name" name="branch_name" placeholder="${branch_name_label}">
                                        </div>
                                        <div class="form-group">
                                            <label for="cashier_name">Branch Employee's Name <span style="color: #DE3C4C;">*</span></label>
                                            <input type="text" class="form-control" id="cashier_name" name="cashier_name" placeholder="Branch Employee's Name">
                                            <small id="cashier_nameHelpBlock" class="form-text text-muted">
                                             This is your name, not the customer’s name.
                                            </small>
                                        </div>
                                        <div class="form-group">
                                            <label for="comments">Comments (optional)</label>
                                            <input type="text" class="form-control" id="comments" name="comments" placeholder="">
                                        </div>
                                    </div>`,
                                    focusConfirm: false,
                                    onBeforeOpen: () => {

                                    },
                                    preConfirm: () => {

                                        var branch_name = $('#branch_name').val();
                                        var cashier_name = $('#cashier_name').val();
                                        var comments = $('#comments').val();

                                        var formData = new FormData();
                                        formData.append("id", response.data.id);
                                        formData.append("branch_name", branch_name);
                                        formData.append("cashier_name", cashier_name);
                                        formData.append("comments", comments);

                                        let countError = 0;

                                        if(branch_name == ''){
                                            countError += 1;
                                            $('#branch_name').addClass('error');
                                        }else{
                                            $('#branch_name').removeClass('error');
                                        }

                                        if(cashier_name == ''){
                                            countError += 1;
                                            $('#cashier_name').addClass('error');
                                        }else{
                                            $('#cashier_name').removeClass('error');
                                        }

                                        //alert(deposit_slip);
                                        if(countError == 0){
                                            Swal.fire({
                                              icon: 'warning',
                                              title: 'Please wait!',
                                              html: 'Redemption is processing...',
                                              showConfirmButton: false,
                                              showCancelButton: false,
                                              allowOutsideClick: false,
                                              allowEscapeKey: false,
                                            });
                                            
                                            $.ajax({
                                                type: "POST",
                                                url: "/api/mark_redeemed",
                                                data: formData,
                                                processData: false,
                                                contentType: false,
                                                cache: false,
                                            })
                                            .then(response => {
                                                if(response.status === "Success"){

                                                    Swal.fire({
                                                        icon: "success",
                                                        title: response.message,
                                                        confirmButtonColor: '#DE3C4C',
                                                        showLoaderOnConfirm: true,
                                                        background: '#fff',
                                                        backdrop: 'rgb(198, 227, 222)',
                                                        html: 'Ref #:'+response.data.ref_number+'<br>Order Number:'+response.data.order_number,
                                                      confirmButtonColor: '#DE3C4C',
                                                      confirmButtonText: 'Close'
                                                    }).then((result) => {
                                                        //if (result.isConfirmed) {
                                                            $(".btn-verify").removeAttr("disabled");
                                                        //}
                                                    });
                                                }else{
                                                    Swal.fire({
                                                        icon: "error",
                                                        title: response.message,
                                                        showConfirmButton: true,
                                                    }).then((result) => {
                                                        //if (result.isConfirmed) {
                                                            $(".btn-verify").removeAttr("disabled");
                                                        //}
                                                    });
                                                }
                                               
                                            })
                                            .catch(error => {
                                                Swal.showValidationMessage(
                                                  `Request failed! Please contact support.`
                                                )
                                            });
                                            

                                        }else{
                                            Swal.showValidationMessage(
                                              `Please complete the required fields.`
                                            );
                                        }

                                    }

                                })

                                /*
                                $('.validate-voucher .card-title h3').text('Voucher Details');
                                $('#validateResults').show();
                                $('#validateResults').html(html_data);
                                $('#validateResults').append('<p style="margin-top: 30px; margin-bottom: 0; text-align: center;"><a href="">Back</a></p>');
                                */

                            }else{

                                console.log('pasok dito');

                                $('#validateForm').hide();
                                $('#validateResults').hide();
                                Swal.close();

                                $('#validateResults').show();
                                $('#validateResults').html(response.message);
                                $('#validateResults').append('<p style="margin-top: 30px; margin-bottom: 0; text-align: center;"><a href="">Back</a></p>');

                            }

                        }else{

                            Swal.fire({
                                  icon: 'error',
                                  title: is_valid.response.message,
                                  showConfirmButton: true,
                                  allowOutsideClick: false,
                                  allowEscapeKey: false
                                }).then((result) => {
                                    //if (result.isConfirmed) {
                                        $(".btn-verify").removeAttr("disabled");
                                    //}
                                });

                        }
                    })
                    .catch(error => {

                        Swal.fire({
                                icon: 'error',
                                title: error.responseJSON.message,
                                showConfirmButton: true,
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    $(".btn-verify").removeAttr("disabled");
                                }
                            });

                    });
                    

                }else{
                    Swal.showValidationMessage(
                          `Please enter Voucher Code.`
                        )
                }
            },
            markRedeemed() {

                alert(1);

                //var voucher_code = document.getElementById('voucher_code').value;

                //return true; // prevent form from submitting


                Swal.fire({
                  icon: 'warning',
                  title: 'Please wait! Processing Redemption...',
                  //html: 'Your voucher is validating...',
                  showConfirmButton: false,
                  allowOutsideClick: false,
                  allowEscapeKey: false
                });

                /*
                return $.ajax({
                    type: "POST",
                    url: "/api/redeem",
                    data: { 'orderNumber': orderNumber, 'recipientEmail': recipientEmail, 'recipientFirstname': recipientFirstname, 'recipientLastname': recipientLastname },
                    cache: false,
                })
                .then(response => {
                    console.log(response);
                    //return response;
                    const result = JSON.parse(response);

                    if(result.response.class == "success"){    
                        Swal.fire({
                          icon: result.response.class,
                          title: result.response.message,
                          html: '',
                          confirmButtonColor: '#DE3C4C',
                          confirmButtonText: 'Close'
                        }).then((result) => {
                            if (result.isConfirmed) {
                                location.reload();
                            }
                        });
                    }else{
                        Swal.fire({
                          icon: result.response.class,
                          title: result.response.message,
                          html: '',
                          showConfirmButton: false,
                        })
                    }
                })
                .catch(error => {
                    Swal.showValidationMessage(
                      `Request failed! Please contact support.`
                    )
                });
                */

            }
        }
    }



</script>
